import iconBackArrow from "../../../Icons/icons-white/back-arrow.png";
import iconWhiteViews from "../../../Icons/icons-white/views.png";
import iconWhiteLikes from "../../../Icons/icons-white/like.png";
import iconWhiteShare from "../../../Icons/icons-white/share.png";
import iconWhiteListed from "../../../Icons/icons-white/listed.png";
import iconBack from "../../../Icons/icons-charcoal-dark/back.png";
import iconBackBlack from "../../../Icons/icons-white/back.png";
import iconAhead from "../../../Icons/icons-charcoal-dark/ahead.png";
import iconCharcoalDarklike from "../../../Icons/icons-charcoal-dark/like.png";
import iconCharcoalDarkliked from "../../../Icons/icons-charcoal-dark/liked.png";
import iconCharcoalDarkSave from "../../../Icons/icons-charcoal-dark/save.png";
import iconCharcoalDarkSaved from "../../../Icons/icons-charcoal-dark/saved.png";
import iconCharcoalDarkShare from "../../../Icons/icons-charcoal-dark/share.png";
import iconCharcoalDarkCall from "../../../Icons/icons-charcoal-dark/call.png";
import iconCharcoalDarkWhatsApp from "../../../Icons/icons-charcoal-dark/whatsapp.png";
import iconCharcoalDarkMenuUp from "../../../Icons/icons-charcoal-dark/menu-up.png";
import iconStar from "../../../Icons/icons-yellow/star.png";
import iconGrayLocation from "../../../Icons/icons-gray/location.png";

import iconSMWhatsApp from "../../../Icons/icons-SM/whatsapp.png";
import iconSMMAIVerified from "../../../Icons/icons-SM/MAI-VERIFIED.png";
import iconSMCall from "../../../Icons/icons-SM/call.png";

import iconBlackViews from "../../../Icons/icons-black/views.png";
import iconBlackShare from "../../../Icons/icons-black/share.png";
import iconBlackSave from "../../../Icons/icons-black/save.png";
import iconBlackSaved from "../../../Icons/icons-black/saved.png";
import iconBlackMoreMenu from "../../../Icons/icons-black/more-menu.png";
import iconBlackInfo from "../../../Icons/icons-black/info.png";



import iconWhiteDotsMenu from "../../../Icons/NV/white/dots menu.png";
import iconWhiteSave from "../../../Icons/NV/white/save.png";
import iconWhiteSaved from "../../../Icons/NV/white/saved.png";
import iconWhiteShare from "../../../Icons/NV/white/share.png";

import iconYellowDotsMenu from "../../../Icons/NV/yellow/dots menu.png";
import iconYellowSave from "../../../Icons/NV/yellow/save.png";
import iconYellowSaved from "../../../Icons/NV/yellow/saved.png";
import iconYellowShare from "../../../Icons/NV/yellow/share.png";
import iconWhiteShare from "../../../Icons/NV/white/share.png";
import iconWhiteLike from "../../../Icons/NV/white/like.png";
import iconWhiteView from "../../../Icons/NV/white/view.png";
import iconWhiteBack from "../../../Icons/NV/white/back.png";
import iconWhiteCall from "../../../Icons/NV/white/call.png";
import iconWhiteWhatsApp from "../../../Icons/NV/white/whatsApp.png";

import iconHomeCatVideos from "../../../Icons/icons-home-catagory/videos.png";

import GENRALHELPERS from "../GENRAL-HELPERS";
import handleAccount from "../register/handle-account";
import firebase from "../firebase";



class GenerateHtml {
  _generateBusinessRewiewStars(number, numberOfRewviews) {
    let starHtml = ``;
    const stars = Math.round(number);
    if (stars === 0) {
      starHtml += `<img style="height: 10px;" src="${iconStar}" alt="">`;
    } else {
      for (let i = 0; i < stars; i++) {
        starHtml += `<img style="height: 10px;" src="${iconStar}" alt="">`;
      }
    }

    return `<div class="RatingStarCon1">
        <div class="RatingStarCon2">
          <div class="RatingStarRatedAtNumber">
            ${number}
          </div>
          <div class="RatingStarCon3">
            ${starHtml}
          </div>
        </div>
      </div>`;
  }
  _returnVideoPlayerForCreateListing(video, id) {
    let idToUse = id || "";

    function isYouTubeUrl(url) {
      // Match 'youtube.com', 'youtu.be', or 'youtube.com/shorts/'
      return /^(https?:\/\/)?(www\.)?(youtube\.com\/|youtu\.be\/|youtube\.com\/shorts\/)/.test(
        url
      );
    }

    function extractYouTubeId(url) {
      let match;
      // Handle Shorts URLs
      if (/youtube\.com\/shorts\/(.+)$/.test(url)) {
        match = url.match(/youtube\.com\/shorts\/([^?&]+)/);
      } else {
        // Handle regular YouTube URLs
        const ytRegex = /(?:youtube\.com\/.*v=|youtu\.be\/)([^&?#]+)/;
        match = url.match(ytRegex);
      }
      return match ? match[1] : null;
    }

    if (!video) return;

    if (isYouTubeUrl(video)) {
      const videoId = extractYouTubeId(video);
      if (videoId) {
        return `
          <div id="${idToUse}" class="floating-video">
            <iframe 
              src="https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0" 
              frameborder="0" 
              allow="autoplay; encrypted-media" 
              allowfullscreen 
              style="width: 100%; height: 180px; border-radius: 10px 10px 0 0;"
            ></iframe>
            <div class="drag-handle" title="Drag me">
              <span class="drag-icon">&#x2630;</span>
              <button class="close-btn" title="Close video">&times;</button>
            </div>
          </div>
        `;
      } else {
        if (id) alert("URL de YouTube inválida");
        return;
      }
    } else {
      // For non-YouTube URLs, check if it is a valid video URL
      const tempVideo = document.createElement("video");
      tempVideo.src = video;
      tempVideo.preload = "metadata";

      return new Promise((resolve) => {
        tempVideo.onerror = () => {
          if (id) alert("El video no se pudo cargar. Verifica la URL.");
          resolve("ERROR");
        };

        tempVideo.onloadedmetadata = () => {
          const videoHTML = `
            <div class="floating-video">
              <video controls preload="metadata" autoplay muted>
                <source src="${video}" type="video/mp4">
              </video>
              <div class="drag-handle" title="Drag me">
                <span class="drag-icon">&#x2630;</span>
                <button class="close-btn" title="Close video">&times;</button>
              </div>
            </div>
          `;
          resolve(videoHTML);
        };
      });
    }
  }

  _returnVideoPlayer(video, id) {
    console.log(video);
    if (!video || video.length < 1) return "";

    function isYouTubeUrl(url) {
      return /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\//.test(url);
    }

    function extractYouTubeId(url) {
      // Handles normal, youtu.be, and shorts links
      const ytRegex =
        /(?:youtube\.com\/.*v=|youtu\.be\/|youtube\.com\/shorts\/)([^&?#]+)/;
      const match = url.match(ytRegex);
      return match ? match[1] : null;
    }

    let videoHTML = ``;
    if (video) {
      if (isYouTubeUrl(video)) {
        const videoId = extractYouTubeId(video);
        if (videoId) {
          videoHTML = `
      <div id="${id}" class="floating-video">
        <iframe 
          src="https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0" 
          frameborder="0" 
          allow="autoplay; encrypted-media" 
          allowfullscreen 
          style="width: 100%; height: 180px; border-radius: 10px 10px 0 0;"
        ></iframe>
        <div class="drag-handle" title="Drag me">
          <span class="drag-icon">&#x2630;</span>
          <button class="close-btn" title="Close video">&times;</button>
        </div>
      </div>
          `;
        } else {
          videoHTML = `<p>URL de YouTube inválida</p>`;
        }
      } else {
        videoHTML = `
      <div class="floating-video">
        <video controls preload="metadata" autoplay muted>
          <source src="${video}" type="video/mp4">
        </video>
        <div class="drag-handle" title="Drag me">
          <span class="drag-icon">&#x2630;</span>
          <button class="close-btn" title="Close video">&times;</button>
        </div>
      </div>
        `;
      }
    }

    return videoHTML;
  }


  _pickClosestClass(width, height) {
    if (!width || !height) return "aspectRatio_16-9"; // fallback
    const actual = width / height;
    let closest = null;
    let bestDiff = Infinity;
    for (const [cls, ratio] of Object.entries(RATIO_MAP)) {
      const diff = Math.abs(actual - ratio);
      if (diff < bestDiff) {
        bestDiff = diff;
        closest = cls;
      }
    }
    return closest;
  }


  async _getClosestAspectRatioClass(url, { crossOrigin = null } = {}) {
    try {
      const img = new Image();
      if (crossOrigin) img.crossOrigin = crossOrigin; // optional: "anonymous"
      img.src = url;

      // If decode() is supported, use it (returns a Promise)
      if (img.decode) {
        // If the image hasn't started loading yet, ensure src is set before decode (we did).
        await img.decode();
      } else {
        // fallback to onload
        await new Promise((resolve, reject) => {
          img.onload = () => resolve();
          img.onerror = () => reject(new Error("Image load error"));
        });
      }

      return this._pickClosestClass(img.naturalWidth, img.naturalHeight);
    } catch (err) {
      // failed to load or decode — return fallback
      console.warn("getClosestAspectRatioClassFromUrl failed:", err);
      return "aspectRatio_16-9";
    }
  }

  _imageDisplayer(imgArr, video, metaData, rationClass, origImg, editRight) {

    console.log(origImg);
    let html = ``
    let allImgsHtml = ``;
    let videoHtml = ``;
    console.log(imgArr)

    imgArr.forEach((img, i) => {
      console.log(img)

      let backgroundImg = ``

      if (1 !== 1) {
        backgroundImg = `<img class="nvImgDisplayerListingEachCon2Bg" src="${img.res_blurred ?? img}">`
      }

      html += `
        <div class="nvImgDisplayerListingEachCon2 ${rationClass} ImgForBigDisplayParentCon">
        ${backgroundImg}
        <img class="nvImgDisplayerListingEachCon2Img ImgForBigDisplay" src="${img.res_500 ?? img}">
        </div>
      `

      let actClass = ""

      if (i < 1) {
        actClass = "nvImgDisplayerListingEachCon3ACT"
      }
      allImgsHtml += `
        <div class="nvImgDisplayerListingEachCon3 ${actClass}">
          <img class="nvImgDisplayerListingEachCon3Img" src="${img.res_200 ?? img}">
        </div>
      `
    });

    // <img class="nvImgDisplayerListingEachCon2BgB" src="${imgArr[0].res_blurred}">

    let finalHtml = `
    ${this._returnVideoPlayer(video)}
      <div data-origimg="${origImg.join("°-°|°-°?°-°|°-°")}" class="nvImgDisplayerListingEachCon1B hasOriginalImages">

        
        <div class="nvImgDisplayerListingEachCon1">
          ${html}
        </div>
        <div class="nvImgDisplayerListingEachCon5">
          ${allImgsHtml}
        </div>  

        <div class="nvImgDisplayerListingEachCon6">
          <div id="btnActionListingOptions" class="nvImgDisplayerListingEachCon7 returnForActionOpenForDisplay openListingEditOptionsGlobal" style="display: ${editRight ? 'flex' : 'none'};">
            <img height="4" src="${iconWhiteDotsMenu}"/>
          </div>
          ${metaData.saveButton}
          <div id="btnActionListingShare" class="nvImgDisplayerListingEachCon7">
            <img height="16" src="${iconWhiteShare}"/>
          </div>
        </div>

        <div class="nvImgDisplayerListingEachCon8">
          <div class="nvImgDisplayerListingEachCon9">
            <div class="nvImgDisplayerListingEachCon10">
              <div class="nvImgDisplayerListingEachCon11">
                <div class="nvImgDisplayerListingEachText1">${metaData.views}</div>
                <img height="6px" src="${iconWhiteView}"/>
              </div>
              ${metaData.sharesHtml}
            </div>
            <div class="nvImgDisplayerListingEachText2">${metaData.time}</div>
          </div>
        </div>
  
      </div>
      `
    return finalHtml
  }



  _generateListing(
    dataIn,
    business,
    imgUrlsIn,
    colors,
    contactInfo,
    openFrom,
    fromEdit,
    rationClass,
  ) {
    const data = dataIn.data
    console.log(data);
    const ads = dataIn.ads
    let time = "Ayer, 4:23pm";
    if (fromEdit !== "true") {
      time = GENRALHELPERS._convertServerTimestampToReadableTime(
        data.createdAt
      );
    }

    let listingSharesHTML = ``;
    let SavedHtml = `
            <div id="btnActionListingSave" class="nvImgDisplayerListingEachCon7" style="display: none;">
              <img height="20" src="${iconWhiteSave}"/>
            </div>
          `;

    const account = firebase._getLatestCurrentUserData();

    const checkIfSaved = (path) => {
      let saved = false;

      if (account && account.activeSaves) {
        if (account.activeSaves.includes(path)) {
          saved = true;
        }
      }

      if (saved) {
        SavedHtml = `
            <div id="btnActionListingSave" class="nvImgDisplayerListingEachCon7" style="display: none;">
              <img height="20" src="${iconWhiteSaved}"/>
            </div>
          `;
      }
    };
    if (account) {
      if (data.businessId) {
        checkIfSaved(
          `businesses/${data.businessId}/listings/${data.listingId}`
        );
      } else {
        checkIfSaved(`listings/${data.listingId}`);
      }
    }
    if (data.businessId) {
      listingSharesHTML = `
          <div class="nvImgDisplayerListingEachCon11">
            <div class="nvImgDisplayerListingEachText1">${GENRALHELPERS._formatNumberShort(data.listingShares)}</div>
            <img height="6px" src="${iconWhiteShare}"/>
          </div>
        `;
    }

    // Price
    let priceToUse = "$ preguntar";

    let priceBeforeHtml = ``;
    let onDiscountTagHtml = ``;
    let listingPriceBefore;

    if (data.listingPriceMarkedAs !== "preguntar") {
      priceToUse = GENRALHELPERS._convertToPrice(
        data.listingPrice,
        data.listingCoin
      );
    }

    if (data.onDiscount && data.listingPriceMarkedAs !== "preguntar") {
      if (data.onDiscount.amount > 0) {
        listingPriceBefore = data.onDiscount.finalPrice;
        console.warn(data.onDiscount);

        priceToUse = GENRALHELPERS._convertToPrice(
          data.onDiscount.finalPrice,
          data.listingCoin
        );

        priceBeforeHtml = `
            <div class="nvListingEachText8">Antes</div>
            <div class="nvListingEachText9">${GENRALHELPERS._convertToPrice(data.listingPrice, data.listingCoin)}</div>
          `;

        onDiscountTagHtml = `
            <div class="nvListingEachCon8">
              <div class="nvListingEachText3">En oferta ahora ${data.onDiscount.percent}%</div>
            </div>
          `;
      }
    }

    // other
    let locationHtml = "";
    let shareWhat = "";

    if (business) {
      shareWhat = "linstingInBusiness";

      locationHtml = `
          <div class="DisplayListingEachCon13C">
            <img style="height: 20px" src="${iconGrayLocation}" alt="" />
            <a class="DisplayListingEachCon13CText" href="${business.place.locationUrl}">${business.place.name}</a>
          </div>
      `;
    } else {
      if (data.place) {
        locationHtml = `
        <div class="DisplayListingEachCon13C">
          <img style="height: 20px" src="${iconGrayLocation}" alt="" />
          <a class="DisplayListingEachCon13CText" href="${data.place.locationUrl}">${data.place.name}</a>
        </div>
        `;
      }
    }

    //  new
    console.warn(data);
    let itmesAvailableHtml = ``;
    let itemMarkedAsHtml = "";
    // let showPrice = "$ preguntar";
    let priceDescriptionHtml = ``;

    if (data?.listingItemsAvailable && data?.listingItemsAvailable > 0) {
      let textToShow = `${data.listingItemsAvailable} unidades disponibles`;
      if (data.listingItemsAvailable === 1) {
        textToShow = `último disponible`;
      }
      if (data.listingItemsAvailable === 2) {
        textToShow = `solo ${data.listingItemsAvailable} unidades disponibles`;
      }
      itmesAvailableHtml = `
          <div class="nvListingEachText6">• ${textToShow}</div>
        `;
    }

    if (data?.listingMarkedAs) {
      itemMarkedAsHtml = `
            <div class="nvListingEachText7">• ${data.listingMarkedAs}</div>
        `;
    }

    // if (data.listingPriceMarkedAs !== "preguntar") {
    //   showPrice = GENRALHELPERS._convertToPrice(priceToUse, data.listingCoin);
    // }

    if (data?.listingPriceMarkedAs && data?.listingPriceMarkedAs.length > 1) {
      priceDescriptionHtml = `
          <div class="nvListingEachText3B">• Precio ${data.listingPriceMarkedAs}</div>
        `;
    }


    let itemConditionHtml = "";
    if (data?.listingCondition) {
      itemConditionHtml = `
          <div class="nvListingEachText5">• ${data.listingCondition}</div>
        `;
    }


    let lives = 'seller'



    if (data.businessId) {
      lives = 'business'
    }

    let from = ''

    if (openFrom) {
      from = 'business'
    }


    let imgsUrls = data.listingImgsIds
    let originalImages = data.listingImgsIds
    if (data?.listingImgsIds?.[0]?.res_200) {
      let imgs = []
      let orgImgs = []
      data.listingImgsIds.forEach(img => {
        imgs.push(img.res_500)
        orgImgs.push(img.res_1000 || img.res_500);
      })
      imgsUrls = imgs
      originalImages = orgImgs
    }



    let adminNotesHtml = "";
    let editRight = false


    const generateAdminPrivilegedHtml = () => {

      console.log(account);

      if (!account) return
      if (data?.businessId) {
        function accountHasBusiness(account, businessId) {
          if (!account || !account.businesses) return false;

          return account.businesses.some(business => business.id === businessId);
        }
        if (!accountHasBusiness(account, data.businessId)) {
          console.log('here');
          return
        }
      } else {
        if (data.sellerId !== account.userId) {
          console.log('here');
          return
        }
      }

      editRight = true


      if (data.adminNotes) {
        adminNotesHtml = `
        <div class="nvListingEachAdminNotesCon1">
          <div class="nvListingEachAdminNotesCon4A">
            <div class="nvListingEachAdminNotesCon3">
              <div class="nvListingEachAdminNotesText1">Notas admin</div>
            </div>
        
            <div class="nvListingEachAdminNotesCon4">
              <div class="nvListingEachAdminNotesText2">${data.adminNotes}</div>
            </div>
          </div>
        </div>
    `
      }
    }

    generateAdminPrivilegedHtml()


    let imagesVideoHTML = this._imageDisplayer(imgsUrls, data.videoUrl, {
      time, views: GENRALHELPERS._formatNumberShort(
        data.listingViews
      ), sharesHtml: listingSharesHTML, saveButton: SavedHtml
    }, rationClass, originalImages, editRight)


    const { callNumber, whatsAppNumber } = contactInfo
    console.log(contactInfo);

    let informationTableDisplay = "flex"
    if (!data?.listingMachineType || data?.listingMachineType?.length < 1) {
      console.log('hiding');
      informationTableDisplay = "none"
    }
    console.log(informationTableDisplay);
    console.log(data.listingMachineType);

    return `
          <div data-lives="${lives}"
            data-from="${from}"
            data-listingId="${data.listingId}"
            data-businessId="${data.businessId}"
            data-sellerId="${data.sellerId}"
            data-share="listing" class="nvListingEachCon1A">

            <div class="nvListingEachCon1C">
              <div class="nvListingEachCon1D">

                ${imagesVideoHTML}

                <div class="nvImgDisplayerListingEachCon12 CloseCurrentStackPageButton">
                  <img height="20px" src="${iconBackBlack}"/>
                </div>



                ${adminNotesHtml}
                <div class="nvListingEachCon1B">
                  <div class="nvListingEachCon1">
                    <div class="nvListingEachText1">${data.listingName}</div>
                  </div>
                  <div class="nvListingEachCon2">
                    <div class="nvListingEachText2">${data.listingDescription}</div>
                  </div>

                  <div class="nvListingEachCon1BC">
                    <div class="nvListingEachCon4">
                      <div class="nvListingEachCon5">
                        <div class="nvListingEachCon6">
                            ${onDiscountTagHtml}
                            <div class="nvListingEachCon7">
                              <div class="nvListingEachText4">${priceToUse}</div>
                            </div>
                        </div>
                      </div>
                      <div class="nvListingEachCon11">
                        ${priceBeforeHtml}
                      </div>
                    </div>



                    <div class="nvListingEachCon9">
                      ${itemConditionHtml}
                      ${itemMarkedAsHtml}
                      ${itmesAvailableHtml}
                      ${priceDescriptionHtml}
                    </div>
                  </div>
                </div>

                
                <div class="nvListingEachCon3" style="display: ${informationTableDisplay}";>

                  <div class="nvListingEachCon18">
                    <div class="nvListingEachCon19">
                      <div class="nvListingEachText15">Información técnica</div>
                    </div>
                    <div class="nvListingEachCon20">
                      <div class="nvListingEachCon21">
                        <div class="nvListingEachText16">Categoría</div>
                        <div class="nvListingEachText17">${data.listingMachineType}</div>
                      </div>
                      <div class="nvListingEachCon21">
                        <div class="nvListingEachText16">Marca</div>
                        <div class="nvListingEachText17">${data.listingBrand}</div>
                      </div>
                      <div class="nvListingEachCon21">
                        <div class="nvListingEachText16">Modelo</div>
                        <div class="nvListingEachText17">${data.listingModel}</div>
                      </div>
                      <div class="nvListingEachCon21">
                        <div class="nvListingEachText16">Año</div>
                        <div class="nvListingEachText17">${data.listingYear}</div>
                      </div>
                      <div class="nvListingEachCon21">
                        <div class="nvListingEachText16">Condición</div>
                        <div class="nvListingEachText17">${data.listingCondition}</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div id="nvListingEachConLocationContainerParent" style="display: none" class="nvListingEachCon3">
                  <div id="nvListingEachConLocationContainer" class="nvListingEachConLocationContainer">
                  </div>


                  <div class="nvListingEachConLocationButtonCon">
                    <div id="nvListingEachConLocationContainerButtonOpenMaps" class="nvListingEachConLocationContainerButtonOpenMaps">Abrir Mapa</div>
                  </div>

                </div>

                ${ads}
              </div>
            </div>



            <div id="nvListingsContactEachCon13C" class="nvListingsContactEachCon13C">
              <div class="nvBusinessContactEachCon13CListingEach">
                <div class="nvBusinessContactEachCon13" style="display: none">
                  <div class="nvBusinessContactEachText10Listing">Ponte en contacto</div>
                  <div class="nvBusinessContactEachCon13B" style="display: none;">
                    <div class="nvBusinessContactEachText10B">@bernardoklassen</div>
                  </div>
                </div>
                <div class="nvBusinessContactEachCon14ListingEach expanded">

                  <a id="btnActionBusinessContactCall" 
                    class="nvBusinessContactEachCon16ListingEach" 
                    href="tel:+${callNumber}">
                    <div class="nvBusinessContactEachText12ListingEach">Llamar</div>
                    <img src="${iconWhiteCall}" height="24px" />
                  </a>

                  <div data-whatsappnumber="${whatsAppNumber}" id="btnActionListingContactWhatsApp" class="nvBusinessContactEachCon15ListingEach">
                    <div class="nvBusinessContactEachText11ListingEach">WhatsApp</div>
                    <img height="24px" src="${iconWhiteWhatsApp}"/>
                  </div>
        
                  <!-- Email button can be added. 'nvBusinessContactEachCon16B' is the button class -->
        
                </div>
                <div class="nvListingEachCon17ListingEach">
                  <div class="nvListingEachText13ListingEach">Resuelve tus dudas,</div>
                  <div class="nvListingEachText14ListingEach">¡y hazlo tuyo ya!</div>
                </div>
              </div>
            </div>
          

            <!-- <div class="nvListingEachCon12">
              <div class="nvListingEachCon12B">
                <div class="nvListingEachCon12C">
                </div>
              </div>
              <div class="nvListingEachCon13">
                <div class="nvListingEachText10">Ponte en contacto con el vendedor</div>
              </div>
              <div class="nvListingEachCon14">
                <div id="btnActionListingContactWhatsApp" class="nvListingEachCon15">
                  <div class="nvListingEachText11">WhatsApp</div>
                  <img height=18px" src="${iconWhiteWhatsApp}"/>
                </div>
                <a id="btnActionListingContactCall" 
                  class="nvListingEachCon16" 
                  href="tel:+52${callNumber}">
                  <div class="nvListingEachText12">Llamar</div>
                  <img src="${iconWhiteCall}" height="18px" />
                </a>
              </div>
              <div class="nvListingEachCon17">
                <div class="nvListingEachText13">Resuelve tus dudas,</div>
                <div class="nvListingEachText14">¡y hazlo tuyo ya!</div>
              </div>
            </div> --!>
          </div>
    `
  }
}

export default new GenerateHtml();
